import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import {
  ReadRoleBasedAssignments,
  WriteRoleBasedAssignments,
} from "@/types/roleBasedAssignments";
import { ReadContractorVisitContractor } from "@/types/contractorVisitContractor";

export const RoleBasedAssignmentsService = new APIService<
  ReadRoleBasedAssignments,
  WriteRoleBasedAssignments
>(API.RoleBasedAssignments);

export const fetchContractorsList = (
  fetchParams?: FetchListRequest<ReadContractorVisitContractor>,
) => {
  const contractorVisitsService = new APIService<ReadContractorVisitContractor>(
    API.ContractorVisits,
  );
  return contractorVisitsService.getList(fetchParams, "/contractors");
};
